import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';
import { buildPatientDataGroups } from '../documentEditor/patientDataFields';

// Patient, professional (logged user) and clinic values for the editor's "Inserir dado" menu.
// Loaded only while the editor is open.
export function usePatientDocumentData(patientId, enabled) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(() => {
    if (!patientId || !enabled) return;
    setLoading(true);
    setError(null);
    quarkusApi
      .get(`/patients/${patientId}/documents/data`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setData(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [patientId, enabled, navigate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Rebuilt on every load so "Data atual" follows the day the editor was opened.
  const groups = useMemo(() => buildPatientDataGroups(data), [data]);

  return { groups, isLoading, error, refetch: fetchData };
}
